/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with❤️ by YalaCoder.
 *
 * --- REWRITE (V2 - Runtime Fix) ---
 * - MISSION: To fix the runtime error "doesn't provide an export named:
 * 'useLoading'" by updating the import path.
 *
 * - THE BUG: A previous refactor moved the `useLoading` hook to its own
 * file, but this component was still trying to import it from the old
 * location (`@/context/LoadingProvider`).
 *
 * - THE FIX: The import path for `useLoading` has been corrected to point
 * to its new, dedicated file: `@/hooks/useLoading`.
 *
 * - RESULT: This resolves the runtime error and allows the application
 * to start correctly in development mode.
 */
import { useEffect } from 'react';
import { useLoading } from '@/hooks/useLoading';

const SuspenseManager = () => {
  // Get the state setter from our global loading context.
  const { setIsLoading } = useLoading();

  useEffect(() => {
    // When this component is mounted by Suspense, set loading to true.
    setIsLoading(true);

    // When the real component loads and this fallback is unmounted,
    // the cleanup function will set loading to false.
    return () => {
      setIsLoading(false);
    };
  }, [setIsLoading]); // Dependency array ensures this runs only once on mount/unmount.

  // This component has no visual output.
  return null;
};

export default SuspenseManager;
